import { useNavigate } from "react-router-dom";

export const useNavigation = () => {
  const navigation = useNavigate();

  const handleClickMenuItem = (path: string) => {
    navigation(path);
  };

  const updateSearchParams = (params: string) => {
    navigation({ search: params }, { replace: true });
  };

  return { handleClickMenuItem, updateSearchParams };
};
